import { useState } from 'react';
import { Tutorial } from '@/components/Tutorial';
import { BottomNavigation } from '@/components/BottomNavigation';
import { Header } from '@/components/Header';

export const TutorialPage = () => {
  const [showTutorial, setShowTutorial] = useState(true);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <BottomNavigation />
      {/* Deprecated: tutorial now overlays globally via Layout; keep page minimal */}
    </div>
  );
};
